import { OccConfig } from '@spartacus/core';

export const customOrdersOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        getOrders: '/users/current/orders/search',
        getOrder: '/users/current/orders/details?uid=${uid}',
        getOrdersExport: '/users/current/orders/export?fromDate=${dateFrom}&toDate=${dateTo}',
      } as any,
    },
  },
};
